// Theme configuration for Ant Design
import { branding } from '../../config/branding';

const primaryColor = branding.primaryColor;

// Set CSS variable for primary color
document.documentElement.style.setProperty('--primary-color', primaryColor);

// Set favicon based on environment
const setFavicon = () => {
  const favicon = document.querySelector('link[rel="icon"]');
  if (favicon) {
    favicon.href = branding.favicon;
  }
  const manifest = document.querySelector('link[rel="manifest"]');
  if (manifest && branding.manifest) {
    manifest.href = branding.manifest;
  }
  document.title = branding.appName;
};

// Execute favicon update when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setFavicon);
} else {
  setFavicon();
}

const theme = {
  token: {
    colorPrimary: primaryColor,
    borderRadius: 6,
    fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  components: {
    Button: {
      colorPrimary: primaryColor,
      borderRadius: 4,
    },
    Input: {
      borderRadius: 4,
    },
    Layout: {
      bodyBg: '#f5f5f5',
      headerBg: '#ffffff',
      footerBg: '#ffffff',
      headerHeight: 64,
      footerHeight: 64,
    },
    Collapse: {
      headerBg: '#ffffff',
      fontSize: 16,
      fontSizeIcon: 16,
    },
    Descriptions: {
      padding: 8,
      paddingLG: 8
    },
    Menu: {
      itemPaddingInline: 0,
    }
  },
};

export default theme;
